document.addEventListener('DOMContentLoaded', function () {
  const scroll_offset_top = getOffset(document.querySelector('.thb-product-detail product-form')).top;
  const scroll_offset_bottom = getOffset(document.querySelector('.jdgm-review-widget')).top;
  document.addEventListener('scroll', () => {
    const stickyATC = document.querySelector('.sticky-atc');
    if (window.scrollY > scroll_offset_top && window.scrollY < scroll_offset_bottom) {
      stickyATC.classList.add('sticky-atc-visible');
    } else {
      stickyATC.classList.remove('sticky-atc-visible');
    }
  });
});
function getOffset(el) {
  const rect = el.getBoundingClientRect();
  return {
    left: rect.left + window.scrollX,
    top: rect.top + window.scrollY
  };
}